
const EmptyTopMenu = () => {
    return (
        <div
            className="flex flex-col justify-center items-start self-stretch py-11 w-full bg-white max-md:pr-5 max-md:max-w-full">
            <div
                className="flex flex-col justify-center items-start pl-20 max-w-full min-h-[36px] w-[185px] max-md:pl-5">
                <img loading="lazy" src="/logo_IC_math.svg" alt="Company Logo"
                     className="object-contain w-full aspect-[3.12]"/>
            </div>
        </div>
    )
}

export default EmptyTopMenu;